/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export type Body_update_transcribe_config_v1_workspace__slug__event__id__transcribe_config_patch = {
  /**
   * 언어
   */
  language?: Body_update_transcribe_config_v1_workspace__slug__event__id__transcribe_config_patch.language;
  /**
   * 반복 일정일 경우, 이 후 일정에도 적용할지 유/무
   */
  recurring?: boolean | null;
};

export namespace Body_update_transcribe_config_v1_workspace__slug__event__id__transcribe_config_patch {
  /**
   * 언어
   */
  export enum language {
    DETECT = 'detect',
    MULTI = 'multi',
    KO = 'ko',
    EN = 'en',
    JA = 'ja',
    ZH = 'zh',
    ES = 'es',
    FR = 'fr',
    DE = 'de',
    RU = 'ru',
    PT = 'pt',
    IT = 'it',
    AR = 'ar',
    HI = 'hi',
    ID = 'id',
    VI = 'vi',
    TH = 'th',
    NL = 'nl',
  }
}
